// Module
var code = `<div class="medialabels medialabels--inline">
	<div class="medialabels--labels--container">
		<span
			ng-repeat="item in \$ctrl.MediaLabels | orderBy:'name' track by item.id"
			class="medialabels--label"
			style="border-color: {{item.color}}; color: {{item.color}}">
			{{item.name}} <span ng-click="\$ctrl.removeLabel(item.id)" class="removeBtn"><i class="fas fa-times"></i></span>
		</span>
	</div>
</div>
`;
// Exports
export default code;